import { defineModuleEvidenceContract } from './moduleEvidenceContract';

export const ORG_PATTERN_COST_EVIDENCE_KEYS = {
  recommendationRun: 'neurotruth_pattern_recommendation_run',
  asIsOrgState: 'org_state_as_is',
  toBeOrgState: 'org_state_to_be',
  positionCostRoster: 'position_cost_roster',
} as const;

const SOURCE_AUTHORITY =
  'OrgPatternCostSource plus the approved formula runtime trusted state-pair reader';

export const ORG_PATTERN_COST_MODULE_EVIDENCE_CONTRACT =
  defineModuleEvidenceContract(
    'org-pattern-cost',
    {},
    {
      evidenceKeys: [],
      sourceClasses: [],
      contextKinds: [],
      schemaVersions: [],
      stateKeys: [],
      bindingPlaceholders: [],
    },
    [
      {
        evidenceKey: ORG_PATTERN_COST_EVIDENCE_KEYS.recommendationRun,
        sourceAuthority: `${SOURCE_AUTHORITY}: NeuroTruthPatternRecommendationRun and its latest pattern decision event.`,
        reason:
          'The accepted recommendation state is read from governed tables, not an artifact substrate.',
      },
      {
        evidenceKey: ORG_PATTERN_COST_EVIDENCE_KEYS.asIsOrgState,
        sourceAuthority: `${SOURCE_AUTHORITY}: baseline OrgState selected by the accepted pattern or the run As-Is fallback.`,
        reason:
          'The baseline organization is a direct governed-table read, not an artifact substrate.',
      },
      {
        evidenceKey: ORG_PATTERN_COST_EVIDENCE_KEYS.toBeOrgState,
        sourceAuthority: `${SOURCE_AUTHORITY}: accepted pattern proposed OrgState.`,
        reason:
          'The proposed organization is a direct governed-table read, not an artifact substrate.',
      },
      {
        evidenceKey: ORG_PATTERN_COST_EVIDENCE_KEYS.positionCostRoster,
        sourceAuthority: `${SOURCE_AUTHORITY}: OrgPositionCost rows joined to the exact state pair.`,
        reason:
          'Position cost is read from the governed cost table and never constructed as an artifact lookup.',
      },
    ],
  );
